export default "__VITE_ASSET__325a0cc5__"